<template>
	<div id="app" ref="app">
		<title-bar v-if="$route.meta.showNavbar"></title-bar>
		<loading v-if="$route.meta.showNavbar && isLoading" />
		<router-view />
	</div>
</template>

<script>
import TitleBar from "./components/common/TitleBar.vue";
import Loading from "./components/common/Loading.vue";
import { checkVersionUpdate, reloadApp } from "@/utils/versionCheck";
export default {
	name: "App",
	components: {
		TitleBar,
		Loading
	},
	created() {},
	computed: {
		isLoading() {
			return this.$permissionStore.state.isLoading;
		}
	},
	mounted() {
		// 开发环境直接跳过版本检查
		if (process.env.NODE_ENV === "development") return;

		// 第一次检查
		this.checkUpdate();

		// 每 5 分钟检查一次
		this.versionTimer = setInterval(() => {
			this.checkUpdate();
		}, 5 * 60 * 1000);
	},
	methods: {
		async checkUpdate() {
			try {
				const needUpdate = await checkVersionUpdate();
				if (needUpdate) {
					await this.$alert("系统已更新，请刷新后使用", "更新提示", {
						confirmButtonText: "立即刷新",
						callback: (action) => {
							reloadApp();
						}
					});
				}
			} catch (err) {
				console.log("版本检查失败:", err);
			}
		}
	},
	beforeUnmount() {
		// 只有生产环境才需要清除定时器
		if (this.versionTimer) {
			clearInterval(this.versionTimer);
		}
	}
};
</script>

<style>
@import "assets/scss/style.scss";

:root {
	--app-page-bg: #f2f4f8;
	--app-surface: #ffffff;
	--app-border: #e7ebf3;
	--app-primary: #1d4ed8;
	--app-primary-soft: #edf4ff;
	--app-text: #1f2937;
	--app-text-muted: #6b7280;
}

html,
body {
	width: 100%;
	/* height: 100%; */
	box-sizing: border-box;
	padding: 0px;
	margin: 0px;
	background-color: var(--app-page-bg) !important;
	letter-spacing: 1px;
	padding-right: 0 !important;
}

#app {
	font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: var(--app-text);
	width: 100%;
	height: 100%;
	overflow: hidden;
}

section {
	height: 100%;
}

.el-input.is-disabled .el-input__inner {
	color: #030304;
	/* font-style: oblique; */
}

.el-dialog {
	background-color: var(--app-surface) !important;
	border: 1px solid var(--app-border);
	border-radius: 12px;
	overflow: hidden;
}

.el-dialog__header {
	background: linear-gradient(180deg, #f9fbff 0%, #f4f7fc 100%);
	padding: 14px 18px;
	border-bottom: 1px solid var(--app-border);
}

.user-search {
	background: var(--app-surface);
	margin: 0 0 10px 0;
	padding: 14px 16px 6px;
}

/* float:right 按钮组始终定位到最后一列右对齐 */
.user-search .el-form-item[style*="float: right"] {
	grid-column-end: -1;
	justify-self: end;
}

/* 防止表单项内容溢出 */
.user-search .el-form-item {
	min-width: 0;
}

.el-dialog__title {
	font-size: 18px;
	font-weight: 600;
	color: var(--app-text);
}

.el-dialog__close {
	background-color: transparent;
}

.el-dialog__headerbtn .el-dialog__close {
	color: #000000;
}

.el-dialog__headerbtn:hover .el-dialog__close {
	color: #000000;
}

.el-message--info {
	background: #f8fafc;
}

.el-message--info .el-message__content {
	color: var(--app-text);
}

.el-button > span {
	margin-left: 5px;
}

.el-dialog__headerbtn {
	top: 14px;
	font-size: 18px;
}

.el-dialog__body {
	background-color: var(--app-surface);
	padding: 18px !important;
}

.el-dialog__footer {
	background-color: var(--app-surface);
	padding: 14px 18px 18px;
}

.el-input__inner {
	border: 1px solid #d6dbe6;
	border-radius: 8px;
}

.el-input__inner:hover {
	border: 1px solid #8cb4ff;
}

.el-select .el-input__inner,
.el-date-editor .el-input__inner,
.el-range-editor.el-input__inner {
	border-radius: 8px;
}

.el-card {
	border: 1px solid var(--app-border);
	border-radius: 12px;
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.03);
	overflow: hidden;
}

.el-card__header {
	padding: 14px 16px;
	background: linear-gradient(180deg, #f9fbff 0%, #f4f7fc 100%);
	border-bottom: 1px solid var(--app-border);
	font-weight: 600;
	color: var(--app-text);
}

.el-card__body {
	padding: 16px;
}

.el-button {
	border-radius: 8px;
	font-weight: 500;
}

.el-button--primary {
	background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
	border-color: #1d4ed8;
}

.el-button--primary:hover,
.el-button--primary:focus {
	background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
	border-color: #1e40af;
}

.el-button--default {
	border-color: #dbe4f0;
	color: #334155;
}

.el-tag {
	border-radius: 999px;
	padding: 0 10px;
	border: none;
	white-space: nowrap;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	height: 1.5rem !important;
	line-height: 1.5rem !important;
}

.el-tabs__nav-wrap::after {
	height: 1px;
	background-color: #e5eaf2;
}

.el-tabs__item {
	color: #64748b;
}

.el-tabs__item.is-active {
	color: #1d4ed8;
	font-weight: 600;
}

.el-pagination {
	padding: 0;
}

.el-empty__description {
	color: #64748b;
}

.el-breadcrumb__inner,
.el-breadcrumb__inner a {
	color: #64748b;
}

.el-form-item {
	margin-bottom: 8px;
	margin-top: 8px;
}

.el-form-item__error {
	padding-top: 0px;
}

.el-tooltip__popper {
	max-width: 800px;
}

.el-button--mini {
	padding: 7px 10px;
}

.pd20 {
	padding: 0 16px 16px;
	height: calc(100vh - 130px);
	background: transparent;
	overflow: auto;
}

.pagination {
	display: flex;
	justify-content: flex-end;
	padding: 12px 0 0;
}

.drawer-footer {
	position: fixed;
	bottom: 0px;
	right: 0px;
	width: 600px;
	height: 50px;
	background: #e6e6e6;
	display: flex;
	align-items: center;
	border-top: 1px solid #d0d0d0;
	padding-left: 20px;
}

.el-drawer__header {
	margin-bottom: 15px;
	padding: 15px 15px;
	border-bottom: 1px solid #eeeeee;
}

/* 弹出框分割线 --目前只包含底部线 */
.dialog-footer {
	display: flex;
	justify-content: flex-end;
	gap: 12px;
}

.fontWeight600 {
	font-weight: 600;
}

.router-tab__item {
	width: auto !important;
	min-width: 0 !important;
	max-width: none !important;
	padding: 0 16px;
	justify-content: center;
	color: #334155 !important;
	font-size: 12px !important;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	background: #dbe4f3;
}

.router-tab__item.is-active {
	width: auto !important;
	min-width: 0 !important;
	max-width: none !important;
	padding: 0 16px;
	justify-content: center;
	background: var(--app-surface);
	color: #1e293b !important;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	font-size: 12px;
}

.router-tab__container {
	background: var(--app-page-bg) !important;
}

/* 标题宽度自适应文字长度，不固定、不省略 */
.router-tab__item-title {
	min-width: 0 !important;
	max-width: none !important;
	overflow: visible !important;
	text-overflow: clip !important;
	white-space: nowrap;
}

.router-tab {
	min-height: 0;
}

.router-tab__item:hover.is-closable {
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	background: #919194;
}

/* 列表主体的高度 */
.table-minheight {
	min-height: calc(100vh - 258px);
	background: var(--app-surface) !important;
	border-radius: 12px;
	border: 1px solid var(--app-border);
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.03);
}

.radius-10 {
	border-radius: 12px;
}

.usercym {
	height: 100%;
	display: flex;
	gap: 16px;
	border-radius: 12px;
}

.user_left {
	width: 260px;
	background-color: var(--app-surface);
	margin-top: 16px;
	max-height: calc(100vh - 160px);
	overflow-y: auto;
	border-radius: 12px;
	border: 1px solid var(--app-border);
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.03);
}

.user_right {
	flex: 1;
	height: calc(100vh - 3.5rem);
	max-height: calc(100vh - 160px);
	padding-left: 0;
}

.pic_bg {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.pic {
	width: 36px;
	height: 36px;
	object-fit: cover;
}

.imgBig {
	width: 100%;
	max-height: 80vh;
	object-fit: contain;
}

.one_1 {
	padding: 2px 16px;
	background: #eaf3ff;
	border: 1px solid #bfd3ff;
	color: #2563eb;
	border-radius: 999px;
	white-space: nowrap;
}

.one_2 {
	padding: 2px 16px;
	background: #f5e9ff;
	border: 1px solid #e2c8ff;
	color: #9333ea;
	border-radius: 999px;
	white-space: nowrap;
}

.down_btn {
	color: #1d4ed8;
	cursor: pointer;
	font-weight: 600;
}

.table_div {
	width: 100%;
	min-height: 20px;
	line-height: 20px;
	display: table;
	color: #475569;
}

.redTip {
	color: #dc2626;
	font-size: 12px;
	padding: 12px 12px;
	background: #fff5f5;
	border: 1px solid #fecaca;
	border-radius: 10px;
	margin: 12px 0;
}

.fontWight600,
.fontWeight600 {
	font-weight: 600;
	font-size: 14px;
	padding-bottom: 3px;
	color: #0f172a;
}

.colorG {
	width: 100%;
	height: 14px;
	border-radius: 999px;
}

/* 面包屑默认样式 */
.el-breadcrumb__inner {
	color: #94a3b8;
}

.el-form--label-top .el-form-item__label {
	padding: 0px 0px;
}

.el-popover {
	max-width: 400px;
	/* 限制宽度 */
	max-height: 400px;
	/* 限制高度 */
	overflow: auto;
	/* 当内容超出时显示滚动条 */
	margin-left: 10px;
}

.el-input-number .el-input__inner {
	text-align: left;
}

.el-message {
	z-index: 99999999 !important;
}

.add_bg {
	width: 800px;
	margin: 0 auto;
}

.input_200px {
	width: 400px !important;
}

.input_dialog {
	width: 1000px !important;
}

.select_200px {
	width: 200px !important;
}

.margin_top_40 {
	margin-top: 3.5rem;
}

.margin_bottom_40 {
	margin-bottom: 0px;
}

.add_bg_800px {
	width: 800px;
	margin: 0 auto;
}

.state_box {
	background: #5ce27f;
	color: #ffffff;
	width: 70px;
	height: 24px;
	border-radius: 3px;
	padding: 0 8px;
	box-sizing: border-box;
	display: inline-block;
	line-height: 24px;
	text-align-last: justify;
}

.separate_div {
	width: 100%;
	height: 10px;
	background: var(--app-page-bg);
}

.line_div {
	width: 100%;
	height: 1px;
	background: var(--app-page-bg);
}

.el-drawer {
	width: 600px !important;
}

.page-section-title {
	padding: 14px 16px 8px;
	font-size: 16px;
	font-weight: 600;
	color: var(--app-text);
}

.page-subtitle {
	padding: 0 16px 10px;
	font-size: 12px;
	color: var(--app-text-muted);
}

.el-table {
	border-radius: 12px;
	overflow: hidden;
}

.el-table thead th {
	background: #f7f9fc !important;
	color: #1f2937;
	font-weight: 600;
	height: 48px;
}

.el-table td,
.el-table th.is-leaf {
	border-bottom-color: #edf0f6;
}
</style>
